// extracted by mini-css-extract-plugin
export default {"msgStyle":"style_msgStyle__X15NM","title1":"style_title1__BeqoA","title2":"style_title2__Nku4a","title3":"style_title3__ED-HY","btn":"style_btn__X5czd"};